import { CDK_REDIRECT_URL } from 'app/App';
import { EXPRESS_API } from 'configs/api/expressApi';
import { COOKIE_NAME } from 'configs/api/types';
import Cookies from 'js-cookie';
import { WHITELABELINFO } from 'lib/context';
import { useMutation } from 'react-query';
import { usersKeys } from './queryKeys';
import { useState } from 'react';
import { isCdkEnvironment } from 'configs/api/enviroments';
import { updateAxiosInstaceToken } from 'configs/api/helpers';

export interface LogoutUserParams {
  redirect?: boolean;
  isSubUser?: boolean;
}

const logoutUser = async ({
  redirect = false,
}: LogoutUserParams): Promise<{ redirectUrl: string; token: string }> => {
  const redirectUrl = redirect ? window.location.href : '';

  const response = await EXPRESS_API.post(
    '/auth/logout',
    {
      redirect: redirectUrl,
    },
    { withCredentials: true }
  );

  return response.data;
};

export const useLogoutUser = () => {
  const [isLogginOut, setIsLoggingOut] = useState(false);

  const handleCdkLogout = ({ isSubUser }: { isSubUser: boolean }) => {
    if (isSubUser && window.opener) {
      window.close();
    }

    const ADMIN_JWT = Cookies.get(COOKIE_NAME.ADMIN_JWT) || '';
    updateAxiosInstaceToken(ADMIN_JWT);

    if (!ADMIN_JWT) {
      window.location.href = CDK_REDIRECT_URL;
      return;
    }

    window.location.reload();
    return;
  };

  const mutation = useMutation(logoutUser, {
    mutationKey: usersKeys.user_logout(),

    onMutate: () => {
      setIsLoggingOut(true);
    },
    onError: () => {
      setIsLoggingOut(false);
    },
    onSuccess: (data, variables) => {
      if (isCdkEnvironment) {
        return handleCdkLogout({ isSubUser: !!variables.isSubUser });
      }
      if (!!variables.isSubUser) {
        if (!!window.opener) {
          window.close();
          return;
        }
        window.location.reload();
        return;
      }

      localStorage.setItem(WHITELABELINFO, '');
      if (data?.redirectUrl) {
        window.location.href = data.redirectUrl;
      } else {
        window.location.reload();
      }
    },
  });

  return { ...mutation, isLoading: isLogginOut || mutation.isLoading };
};
